/**
 * Override-proof скролл окна.
 *
 * Host-страницы клиентов (Andys — MODX + jQuery scroll-плагины) переопределяют
 * `window.scrollTo` / `window.scroll` в no-op (override даже рапортует
 * `[native code]`), поэтому `window.scrollTo({top:0})` в embed молча ничего не
 * делает. Прямое присваивание `scrollTop` документному scroller'у их override
 * перекрыть НЕ может и работает и в standalone, и в embed (проверено на живой
 * Andys host page — см. #1166 / mr#1111).
 *
 * Тратим на smooth-анимацию: присваивание `scrollTop` мгновенное. Это
 * осознанный размен — на хайджекнутой host-странице `behavior:'smooth'` и так
 * не скроллил вовсе; корректность важнее плавности.
 */

/** Документный scroller (обычно `<html>`; `<body>` в quirks-mode). */
function getScroller() {
  return document.scrollingElement || document.documentElement;
}

/**
 * Мгновенно проскроллить страницу наверх (override-proof).
 *
 * `instant` — мимо `scroll-behavior: smooth` документа: на витрине он стоит
 * на `html` (для якорей), и сброс при смене страницы иначе ехал бы наверх
 * через всю страницу на глазах (#1335).
 */
export function scrollWindowToTop({ instant = false } = {}) {
  const scroller = getScroller();
  if (scroller && instant) {
    const prev = scroller.style.scrollBehavior;
    scroller.style.scrollBehavior = 'auto';
    scroller.scrollTop = 0;
    scroller.style.scrollBehavior = prev;
  } else if (scroller) scroller.scrollTop = 0;
  // Fallback на редкий случай, когда scrollingElement недоступен, а реальный
  // скролл живёт на body; в стандартном режиме это безвредный no-op.
  if (document.body && document.body !== scroller) document.body.scrollTop = 0;
}

/** Мгновенно проскроллить страницу вниз (override-proof). */
export function scrollWindowToBottom() {
  const scroller = getScroller();
  if (scroller) scroller.scrollTop = scroller.scrollHeight;
  if (document.body && document.body !== scroller) {
    document.body.scrollTop = document.body.scrollHeight;
  }
}
